export const MIN_NUM_REVIEWS = 5;
export const MAX_NUM_REVIEWS = 30;
export const MAX_STARS = 5;
